import React, { useState } from 'react';
import { useUser } from '../contexts/UserContext';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { PasswordResetForm } from './PasswordResetForm';
import { Loader } from '@mantine/core';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { currentUser, isAuthenticated, isLoading, login } = useUser();
  const [authMode, setAuthMode] = useState<'login' | 'register' | 'reset'>('login');

  if (isLoading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        gap: '16px'
      }}>
        <Loader type="bars" size="lg" />
        <p style={{ color: 'var(--app-text-secondary)', fontSize: '14px' }}>
          Checking authentication status
        </p>
      </div>
    );
  }

  if (!isAuthenticated || !currentUser) {
    if (authMode === 'login') {
      return (
        <LoginForm
          onLogin={login}
          onSwitchToRegister={() => setAuthMode('register')}
          onSwitchToPasswordReset={() => setAuthMode('reset')}
        />
      );
    } else if (authMode === 'register') {
      return (
        <RegisterForm
          onRegister={login}
          onSwitchToLogin={() => setAuthMode('login')}
        />
      );
    } else {
      return (
        <PasswordResetForm
          onSwitchToLogin={() => setAuthMode('login')}
        />
      );
    }
  }

  return <>{children}</>;
};
